// A bare URL in the text, up to the first whitespace. Where it ends is decided afterwards, by
// trimSentenceTail: a regex cannot tell "(\u0441\u043C. https://a.ru/x)" from a path that really contains a
// bracket. `www.` without a scheme is included because people write addresses that way.
export const BARE_URL = /(?:(?<![\w@/.-])|(?<=__))(https?:\/\/|www\.|(?:pm0\.ru|pm\.openstart\.ru)\/)[^\s<>"']+/gi;

/** Punctuation a sentence leaves stuck to a URL. Closing brackets only when nothing opened them
 *  inside the link itself, so a Wikipedia-style path keeps its own parenthesis. */
function trimSentenceTail(candidate: string): string {
  let text = candidate;
  for (;;) {
    const last = text.at(-1);
    if (!last) return text;
    // `*` is here for "**https://\u2026**": the emphasis markers belong to the sentence, not the address.
    if ('.,;:!?\u2026\u00BB\u201D\u2019*\'"'.includes(last)) { text = text.slice(0, -1); continue; }
    const opener = { ')': '(', ']': '[', '}': '{' }[last];
    if (opener && !text.slice(0, -1).includes(opener)) { text = text.slice(0, -1); continue; }
    return text;
  }
}

/** Preserve URL underscores while separating the surrounding B/U/I wrappers.
 * Shared by the safe sent-message renderer and visual editor source parser. */
export function splitMarkdownBareUrl(source:string,match:string,offset:number):{link:string;tail:string}|null {
 let wrapperStart=offset;
 while(wrapperStart>0&&(source[wrapperStart-1]==='*'||source[wrapperStart-1]==='_'))wrapperStart--;
 const wrappers=source.slice(wrapperStart,offset);
 const closing=wrappers.includes('__')?[...wrappers].reverse().join(''):'';
 const closeAt=closing?match.lastIndexOf(closing):-1;
 if(closing&&closeAt<0&&source[offset-1]==='_')return null;
 const link=trimSentenceTail(closeAt>=0?match.slice(0,closeAt):match);
 return link?{link,tail:match.slice(link.length)}:null;
}
